import { YardBlockStacksApi, YardBlockStacksApiYardBlockStacksGetYardBlockStacksRequest } from '@storage/app/api'
import { createApiClient } from '@storage/app/http-client'

export class YardBlockStackService {
  public async loadAllStacks(query: YardBlockStacksApiYardBlockStacksGetYardBlockStacksRequest) {
    const { data: stacks } = await createApiClient(YardBlockStacksApi).yardBlockStacksGetYardBlockStacks(query)
    return stacks
  }
}
